module.exports = __webpack_public_path__ + "static/media/proj12.76bf75c0.PNG";